/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CategoryView',["$log","ServiceView","CategoryData","ServiceData","Category","CategorySrv","ServiceSrv","StyleColor",
            "ItemCategoryView","gettextCatalog", "Auth", "Constants",
        function ($log,ServiceView,CategoryData,ServiceData,Category,CategorySrv,ServiceSrv,StyleColor,ItemCategoryView,gettextCatalog, Auth, Constants)
        {
        var styleDefaut = {background : 'white'};
        var  CategoryView = function (category,catIndex,parentCategoryView,domainView)
        {
            ItemCategoryView.call(this);

            this.catIndex = catIndex;
            this.domainView = domainView;
            this.label = "";
            this.description = "";
            this.servicesView = [];
            this.categoriesView = [];
            this.image = null;
            this.companyImage = null;
            this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
            this.styleView = {};  //styleView is an object and category.style is a string
            this.colorPicker = ""; //value liked by the colorpicker
            this.specificImage = null;
            this.isVisibleOnWebSite = true;
            this.parentCategoryView = null;
            this.isSelResKnow = false; // if the selected Ressource know at least one service of the category
            this.selectedServiceView=null;
            this.displayType ="array";// only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
            this.displayServiceImages = true;// only on view if children images are different than son
            this.isVisible = true;
            if (parentCategoryView!==undefined && parentCategoryView!=null) {
                this.parentCategoryView = parentCategoryView;
            }

            this.styleView = this.getStyleFrom(category);
            if (this.styleView) {
                this.colorPicker = this.styleView.background;
            }

            if (category!==undefined && category!=null) {
                this.loadDataFrom(category);
                for (var i=0;i< category.categories.length;i++)
                    this.categoriesView.push(new CategoryView(category.categories[i],CategoryData.getIndexOf(category.categories[i]),this,domainView));
                for (var j=0;j< category.services.length;j++)
                {
                    let serviceView;
                    if(this.domainView && this.domainView.findServiceView!==undefined){
                        serviceView =  this.domainView.findServiceView(category.services[j]);
                        if(serviceView != undefined)
                            this.servicesView.push(serviceView);
                    }
                    if(!serviceView){
                        serviceView  = new ServiceView(category.services[j],ServiceData.getIndexOf(category.services[j]),this,domainView);
                        this.servicesView.push(serviceView);
                        if (this.domainView && this.domainView.addServiceViewIndex!==undefined){
                            this.domainView.addServiceViewIndex(serviceView);
                        }
                    }
                }
            }
        };

        CategoryView.prototype = Object.create(ItemCategoryView.prototype);//inherit functions from ItemCategoryView

        CategoryView.prototype.setImage = function(image)
        {
            for (var j=0;j< this.servicesView.length;j++)
                if (this.servicesView[j].image==null && !this.servicesView[j].specificImage)//if same than previous change
                    this.servicesView[j].setImage(image)
            this.image = image;
            this.companyImage = null;
            this.imageDisplayed = this.image;

        };

        CategoryView.prototype.setCompanyImage = function(companyImage)
        {
            for (var j=0;j< this.servicesView.length;j++)
                if (this.servicesView[j].companyImage==null && !this.servicesView[j].specificImage)//if same than previous change
                    this.servicesView[j].setImage(companyImage)
            this.image = null;
            this.companyImage = companyImage;
            this.imageDisplayed = this.companyImage;
        };
        CategoryView.prototype.loadProductsView  = function()
        {
            for (var j = 0; j < this.servicesView.length; j++)
                this.servicesView[j].loadProductsView()
            for (var z=0;z< this.categoriesView.length;z++)
                this.categoriesView[z].loadProductsView();
        };
        CategoryView.prototype.getCategoryView  = function(category)
        {
            var categoryView =null;
            if (this.getModel()===category)
                return this;
            for (var i=0;i< this.categoriesView.length && categoryView==null;i++)
                categoryView = this.categoriesView[i].getCategoryView(category);
            return categoryView;
        } ;
        CategoryView.prototype.getCategoryViewByLabel  = function(label)
        {
            var categoryView =null;
            if (this.label==label)
                return this;
            for (var i=0;i< this.categoriesView.length && categoryView==null;i++)
                categoryView = this.categoriesView[i].getCategoryViewByLabel(label);
            return categoryView;
        };

        CategoryView.prototype.getServiceView  = function(service)
        {
            var serviceView = null;
            for (var j = 0; j < this.servicesView.length && !serviceView;  j++)
                if (this.servicesView[j].getModel() === service)
                    return this.servicesView[j];
                else
                    if (this.servicesView[j].isPackage)
                        serviceView =  this.servicesView[j].getSubServiceView(service);
            for (var z=0;z< this.categoriesView.length && !serviceView;z++)
                serviceView = this.categoriesView[z].getServiceView(service);

            return serviceView;
        };

        CategoryView.prototype.copyDataTo = function(category)
        {
            //Assume here than the object in parameter contains only id (must load them)
            category.label = this.label;
            category.description = this.description;
            if (this.parentCategoryView && this.styleView===this.parentCategoryView.styleView)// if is specific set it
                category.style = null;
            else
                category.style = angular.toJson(this.styleView);
            category.image = this.image;
            category.companyImage = this.companyImage;
            category.specificImage = this.specificImage;
            category.isVisibleOnWebSite = this.isVisibleOnWebSite;
            category.isVisible = this.isVisible;
        };
        CategoryView.prototype.loadDataFrom = function(category)
        {
            this.label = category.label;
            this.description = category.description;
            this.image = category.image;
            this.companyImage = category.companyImage;
            this.specificImage = category.specificImage;
            if (this.companyImage)
                this.imageDisplayed = this.companyImage;
            else
                this.imageDisplayed = this.image;
            this.isVisibleOnWebSite = category.isVisibleOnWebSite;
        };
        CategoryView.prototype.onStyleViewChange = function()
        {
            var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
            if (!this.styleView || this.styleView.background != this.colorPicker)
            {

                if (!this.styleView ||//if undefined
                    (this.parentCategoryView && this.parentCategoryView.styleView === this.styleView  )) {// if same than parent : break inheritance

                    var newStyle = {
                        background : this.colorPicker,
                        color : fontColor
                    };
                    this.updateStyleView(newStyle);
                    this.styleView = newStyle;
                }
                else{
                    this.styleView.background = this.colorPicker;
                    this.styleView.color = fontColor;
                }
            }
        };
        CategoryView.prototype.updateStyleView = function(styleView)
        {
            //update colorpicker from subcategories
            for (var j=0;j< this.categoriesView.length;j++) {
                if (this.categoriesView[j].styleView === this.styleView) {
                    this.categoriesView[j].colorPicker = styleView.background;
                    this.categoriesView[j].updateStyleView(styleView);
                    this.categoriesView[j].styleView = styleView;
                }
            }

            //update colorpicker from subservices
            for (var j=0;j< this.servicesView.length;j++) {
                if (this.servicesView[j].styleView === this.styleView) {
                    this.servicesView[j].styleView = styleView;
                    this.servicesView[j].colorPicker = styleView.background;
                }
            }
        };
        CategoryView.prototype.getStyleFrom = function(category)
        {
            var styleView = null;
            if (category)
                if (category.style && category.style.indexOf('{')!=0) //Previous type before 1.5 was not contains a jsonSTring
                    styleView = null;
                else
                    try {
                        styleView = angular.fromJson(category.style);
                    }
                    catch (ex) {
                        console.log("Error loading style")
                    }
            if (!styleView)
                if (this.parentCategoryView!=null)
                    styleView = this.parentCategoryView.styleView;
                else
                    styleView = styleDefaut;
            return styleView;
        }
        CategoryView.prototype.isChanged = function()
        {
            var category = this.getModel();
            if (category)
            {
                /*var image = category.image;
                if ((image==null||image=="") &&this.parentCategoryView)
                    image = this.parentCategoryView.image;*/
                var styleView  = this.getStyleFrom(category);
                var styleChanged = (this.styleView && !styleView) ||
                    !this.styleView && styleView ||
                    (this.styleView && styleView &&
                     this.styleView.background != styleView.background);
                return (
                    this.label != category.label ||
                    this.description != category.description ||
                    styleChanged ||
                    this.image != category.image ||
                    this.companyImage !=  category.companyImage
                );

            }
            else
                return true;

        };

        CategoryView.prototype.getAllServicesView  = function()
        {
            var servicesView = [];
            for (var j = 0; j < this.servicesView.length; j++)
                if ((this.servicesView[j]))
                    servicesView.push(this.servicesView[j]);

            for (var z=0;z< this.categoriesView.length ;z++)
                servicesView = servicesView.concat(this.categoriesView[z].getAllServicesView());
            return servicesView;
        };

        CategoryView.prototype.getServicesViewByLabel  = function(label)
        {
            var servicesView = [];
            for (var j = 0; j < this.servicesView.length; j++)
                if ((this.servicesView[j].label && this.servicesView[j].label.toLowerCase().indexOf(label)!=-1))
                    servicesView.push(this.servicesView[j]);

            for (var z=0;z< this.categoriesView.length ;z++)
                servicesView = servicesView.concat(this.categoriesView[z].getServicesViewByLabel(label));
            return servicesView;
        };
        CategoryView.prototype.getServiceViewById  = function(id)
        {
            var service;
            for (var j = 0; j < this.servicesView.length; j++)
            {
                service = this.servicesView[j].getModel();
                if (service && service.id == id)
                    return this.servicesView[j];
            }
            var serviceView= null;
            for (var z=0;z< this.categoriesView.length&&!serviceView ;z++)
                serviceView = this.categoriesView[z].getServiceViewById(id);
            return serviceView;
        };
        CategoryView.prototype.getCategoryViewById  = function(id)
        {
            var categoryView = null;
            var category = this.getModel();
            if (category && category.id ==id)
                return this;
            for (var z=0;z< this.categoriesView.length && !categoryView;z++)
                categoryView = this.categoriesView[z].getCategoryViewById(id);
            return categoryView;
        };

        CategoryView.prototype.getModel = function()
        {
            if (this.catIndex!=-1)
                return CategoryData.getByIndex(this.catIndex);
            return null;
        };
        CategoryView.prototype.restoreModel = function()
        {   //undeleted
            var category = this.getModel();
            if (category)
            {
                if (category.parentCategory)
                    category.parentCategory.addCategory(category);
                CategorySrv.restore(category);
            }

        }
        CategoryView.prototype.updateModel = function(successFunction, errorFunction)
        {
            var category = this.getModel();
            if (category==null)
            {
                category = new Category();
                this.catIndex = CategoryData.getIndexOf(category);
            }


            this.copyDataTo(category);
            if (this.parentCategoryView)
            {
                var parentCategory = this.parentCategoryView.getModel();
                if (parentCategory && parentCategory!==category.parentCategory) // change of category
                {
                    if (category.parentCategory)
                        category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
            }
            category.categories = [];
            for (var i=0;i<this.categoriesView.length;i++)
                category.addCategory(this.categoriesView[i].getModel());
            category.services = [];
            for (var i=0;i<this.servicesView.length;i++)
                category.addService(this.servicesView[i].getModel());
            CategorySrv.save(category, successFunction, function() {
                this.checkForRootSaveError();
                if (errorFunction) {
                    errorFunction();
                }
            });
        };

        CategoryView.prototype.computeViewsImpactedByImportAndCountServices = function() {
            let importData = {
                categoryViewsToUpdate: [],
                serviceCount: 0
            };
            if (this.impactedByImport) {
                importData.categoryViewsToUpdate.push(this);
                this.impactedByImport = false;
            }
            for (let j = 0; j < this.servicesView.length; j++) {
                importData.serviceCount = importData.serviceCount + 1;
            }
            for (let j = 0; j < this.categoriesView.length; j++) {
                let subCategoryTreeImportData = this.categoriesView[j].computeViewsImpactedByImportAndCountServices();
                importData.categoryViewsToUpdate = importData.categoryViewsToUpdate.concat(subCategoryTreeImportData.categoryViewsToUpdate);
                importData.serviceCount = importData.serviceCount + subCategoryTreeImportData.serviceCount;
            }
            return importData;
        };

        CategoryView.prototype.reloadModel = function()
        {
            var category = this.getModel();
            if (category == null)
            {
                this.parentCategoryView.removeCategoryView(this);
            }
            else
            {
                var styleView = this.getStyleFrom(category);
                if (this.styleView && styleView)
                {
                    this.styleView.background = styleView.background;
                    this.styleView.color = styleView.color;
                }
                else
                    this.styleView = styleView;
                this.colorPicker = this.styleView.background;

                this.loadDataFrom(category)
            }
        }
        CategoryView.prototype.removeModel = function()
        {
            var category = this.getModel();
            if (category!=null)
            {
                category.parentCategory.removeCategory(category);
                CategorySrv.remove(category);
            }
        }

        CategoryView.prototype.setSkills = function(resource)
        {
            //if one service is known by resource : category is known
            this.isSelResKnow = false;
            for (var i=0;i< this.categoriesView.length;i++)
                this.isSelResKnow =  this.categoriesView[i].setSkills(resource) || this.isSelResKnow ;
            for (var j=0;j< this.servicesView.length;j++)
                this.isSelResKnow = this.servicesView[j].setSkills(resource) || this.isSelResKnow ;
            return this.isSelResKnow;
        }
        CategoryView.prototype.removeSelections = function()
        {
            //if one service is known by humanResource : category is known
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].removeSelections();
            for (var j=0;j< this.servicesView.length;j++)
                this.servicesView[j].isSelected=false;
        };
        CategoryView.prototype.removeCustomerSelections = function()
        {
            //if one service is known by humanResource : category is known
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].removeCustomerSelections();
            for (var j=0;j< this.servicesView.length;j++)
            {
                this.servicesView[j].nbSelectableForCure = 0;
                this.servicesView[j].nbSelectableForGift = 0;
            }
        };
        CategoryView.prototype.addCategoryView = function(categoryView)
        {
            let index = this.categoriesView.indexOf(categoryView);
            if (index==-1) {
                this.categoriesView.push(categoryView);

                let hasNoStyle = false;
                if (!categoryView.styleView ||//if undefined
                    (categoryView.parentCategoryView && categoryView.parentCategoryView.styleView===categoryView.styleView))// if same than parent : break inheritance
                    hasNoStyle = true;

                categoryView.parentCategoryView = this;

                if(hasNoStyle){
                    categoryView.updateStyleView(this.styleView);
                    categoryView.styleView = this.styleView;
                }
            }
        }

        CategoryView.prototype.removeCategoryView = function(categoryView)
        {
            var index = this.categoriesView.indexOf(categoryView);
            if (index!=-1)
                this.categoriesView.splice(index,1);

        }
        CategoryView.prototype.addServiceView = function(serviceView)
        {
            var index = this.servicesView.indexOf(serviceView);
            if (index==-1)
            {
                this.servicesView.push(serviceView);

                var hasNoStyle = false;
                if (!serviceView.styleView ||//if undefined
                    (serviceView.parentCategoryView && serviceView.parentCategoryView.styleView===serviceView.styleView ))// if same than parent : break inheritance
                    hasNoStyle = true;

                serviceView.parentCategoryView = this;

                if(hasNoStyle)
                    serviceView.styleView = this.styleView;
            }
        }

        CategoryView.prototype.removeServiceView = function(serviceView)
        {
            var index = this.servicesView.indexOf(serviceView);
            if (index!=-1)
            {
                this.servicesView.splice(index,1);
            }


        };

        CategoryView.prototype.populateHomeItemsView = function(homeItemsView) {
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].populateHomeItemsView(homeItemsView);
            for (var j=0;j< this.servicesView.length;j++)
                if(this.servicesView[j].isOnHome)
                    homeItemsView.push({type:'service', item : this.servicesView[j],active:false});
        }
        //CategoryView.prototype.loadWidgetsView = function() {
        //    for (var i=0;i< this.categoriesView.length;i++)
        //        this.categoriesView[i].loadWidgetsView();
        //    for (var j=0;j< this.servicesView.length;j++)
        //        this.servicesView[j].loadWidgetsView();
        //};


        CategoryView.prototype.changeCategoryPosition = function(scope,categoryView,indexTarget)
        {
            //Change the category position
            // This : parentCategory
            // categoryView : category to move to indexTarget
            var category = this.getModel();
            var index = this.categoriesView.indexOf(categoryView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
            {
                this.categoriesView.splice(index,1); //remove it
                category.categories.splice(index,1);
                scope.$apply();//TODO CHECK WHY Two APPLYs ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.categoriesView.length)
                {
                    this.categoriesView.push(categoryView);
                    category.categories.push(categoryView.getModel());
                }
                else
                {
                    this.categoriesView.splice(indexTarget,0,categoryView);//insert
                    category.categories.splice(indexTarget,0,categoryView.getModel());
                }
                CategorySrv.save(category, null, this.checkForRootSaveError);
            }
            scope.$apply();


        }
            CategoryView.prototype.changeCategoryPositionView = function(categoryView,indexTarget)
            {
                //Change the category position
                // This : parentCategory
                // categoryView : category to move to indexTarget
                var index = this.categoriesView.indexOf(categoryView);
                if (indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
                {
                    this.categoriesView.splice(index,1); //remove it
                    if (indexTarget==this.categoriesView.length)
                        this.categoriesView.push(categoryView);
                    else
                        this.categoriesView.splice(indexTarget,0,categoryView);//insert
                }
            };
            CategoryView.prototype.changeServicePosition = function(scope,serviceView,indexTarget)
        {
            //Change the category position
            // This : parentCategory
            // serviceView : service to move to indexTarget

            var category = this.getModel();
            var index = this.servicesView.indexOf(serviceView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.servicesView && indexTarget<=this.servicesView.length)
            {
                this.servicesView.splice(index,1); //remove it
                category.services.splice(index,1);
                scope.$apply();//TODO CHECK WHY TO APPLY ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.servicesView.length)
                {
                    this.servicesView.push(serviceView);
                    category.services.push(serviceView.getModel());
                }
                else
                {
                    this.servicesView.splice(indexTarget,0,serviceView);//insert
                    category.services.splice(indexTarget,0,serviceView.getModel());
                }
                CategorySrv.save(category, null, this.checkForRootSaveError);
                scope.$apply();

            }

        }
        CategoryView.prototype.changeServicePositionView = function(serviceView,indexTarget)
        {
            //Change the service position

            var index = this.servicesView.indexOf(serviceView);
            //Todo check indexTarget!=index
            if (indexTarget!=-1 && index!=-1 &&  this.servicesView && indexTarget<=this.servicesView.length)
            {
                this.servicesView.splice(index,1); //remove it
                if (indexTarget==this.servicesView.length)
                    this.servicesView.push(serviceView);
                else
                    this.servicesView.splice(indexTarget,0,serviceView);//insert
            }
        };
        CategoryView.prototype.duplicateCategory = function(successFunction, errorFunction) {
            let category = this.getModel();
            if(category) {
                CategorySrv.duplicateCategory(category, successFunction, errorFunction);
            }
        };
        CategoryView.prototype.countCurrentServices = function(successFunction, errorFunction) {
            return CategorySrv.countCurrentServices(successFunction, errorFunction);
        };
        CategoryView.prototype.moveService = function(serviceView)
        {
            if (serviceView)
            {
                var service = serviceView.getModel();
                var category = this.getModel();
                if (service && category)
                {
                    if (serviceView.parentCategoryView)
                    {
                        var index = serviceView.parentCategoryView.servicesView.indexOf(serviceView);
                        if (index!=-1)
                        {
                            serviceView.parentCategoryView.servicesView.splice(index,1);
                            service.parentCategory.services.splice(index,1);

                        }
                    }
                    this.addServiceView(serviceView);
                    category.addService(service)
                    ServiceSrv.save(service);
                }
            }
        }
        CategoryView.prototype.moveCategory = function(categoryView)
        {
            if (categoryView)
            {
                var categoryToMove = categoryView.getModel();
                var category = this.getModel();
                if (categoryToMove && category)
                {
                    if (categoryView.parentCategoryView)
                    {
                        var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                        if (index!=-1)
                        {
                            categoryView.parentCategoryView.categoriesView.splice(index,1);
                            categoryToMove.parentCategory.categories.splice(index,1);
                        }

                    }
                    this.addCategoryView(categoryView)
                    category.addCategory(categoryToMove)
                    CategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
                }
            }
        }
        CategoryView.prototype.canSave = function() {
            return this.label && this.label !== "";
        };
        CategoryView.prototype.initWebDisplay = function(forceTo) {
            for (let i = 0; i < this.categoriesView.length;i++) {
                this.categoriesView[i].initWebDisplay(forceTo);
            }
            this.displayServiceImages = false;
            for (let j = 0;j < this.servicesView.length && !this.displayServiceImages;j++) {
                if (this.servicesView[j].imageDisplayed !== this.imageDisplayed) {
                    this.displayServiceImages = true;
                }
            }
            for (let j = 0;j < this.categoriesView.length && !this.displayServiceImages;j++) {
                if (this.categoriesView[j].imageDisplayed !== this.imageDisplayed) {
                    this.displayServiceImages = true;
                }
            }
            if (forceTo !== undefined && forceTo!= "") {
                this.displayType = forceTo;
            }
            else {
                if (this.displayServiceImages) {
                    this.displayType = "thumbnail";
                }
                else {
                    this.displayType = "array";
                }
            }
        };
        CategoryView.prototype.populateDisplayTypeResource = function(array)
        {
            var defaultDType =  this.displayServiceImages ? "thumbnail" : "array";
            if (this.displayType!=defaultDType)
            {
                var cat = this.getModel();
                if (cat)
                    array.push({id:cat.id,type:this.displayType});
            }
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].populateDisplayTypeResource(array);
        };

        return CategoryView;
}]);



// WEBPACK FOOTER //
// ./js/services/views/CategoryView.js